<template>
  <div class="box-card">
    <div class="card-header">
      <span>商品详情</span>
    </div>
    <div class="box-content">
      <div class="image" :style="'background:url('+order.goodsimg+') no-repeat;background-size:100%;'"></div>
      <div class="name">
        <p>{{order.goodsname}}</p>
        <p>
          {{order.attrs}}
        </p>
      </div>
      <div class="price">  <p>¥<span>{{parseInt(order.amount)+parseInt(product.bonus_price)+parseInt(bonus.value)}}</span></p></div>
      <div class="num">
        <span>x {{order.number}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:["order","product","bonus"]
};
</script>

<style scoped>
.box-card {
  width: 3.49rem;
  margin: 0.16rem auto 0rem;
  box-shadow:0rem 0rem 0.04rem rgba(134,130,130,0.3);
    background: #fff;
  border-radius: 0.05rem;
  position: relative;
}
.card-header {
  padding:0.17rem 0rem 0.12rem 0.16rem;
}
.box-content {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding-bottom:0.19rem ;
}
.image {
  width: 0.8rem;
  height: 0.8rem;
  background-size: 100%;
  display: inline-block;
}
.name {
  width:1.73rem;
  font-size: 0.14rem;
}
.name p:nth-child(1) {
  margin-top:0.12rem;
}
.name p:nth-child(2) {
  color: #999;
  margin-top:0.12rem;
}
.price {
  position: absolute;
  top: 0.1rem;
  right:0.17rem;
}
.price p {
  font-size: 0.1rem;
  color: #f9415d;
  text-align: right;
}
.price p span{
  font-size: 0.16rem;
  margin-left:0.02rem;
}
.num {
  position: absolute;
  top: 0.4rem;
  right: 0.17rem;
  color: #666;
  font-size: 0.12rem;
}
</style>
